import { useState } from "react";
import { Icon } from "@mui/material";

import MDBox from "components/MDBox";
import MDButton from "components/MDButton";

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";

import {
  getCompanyList,
  getCompanyStatusCount,
  activeCompany,
  deactiveCompany,
} from "services/data.internal.service";
import { getbillinglistbycustomer,getBillingStatusCount,deactiveBilling,activeBilling} from "services/data.billing.service";
import BasicTable from "ui-components/tables/BasicTable";
import { ListLayout, TableCard } from "ui-components/Layout";
import { EditButton, ActiveButton, DelButton } from "ui-components/IconButton";
import { Success, Error_, MessageDialog } from "ui-components/Alert";
import BasicTabs from "ui-components/BasicTabs";
import { useTeamValue } from "providers/TeamContext";
import { useCustomerValue } from "providers/CustomerContext";

function BillingList() {
  const navigate = useNavigate();
  const {permissions, allowAll} = useTeamValue();
  const {customerCode} = useCustomerValue()
  const [alert, setAlert] = useState(null);
  const [dialog, setDialog] = useState(null);
  const [status, setStatus] = useState("Active");
  const active = status === "Active" ? true : false;
  const [tabs, setTabs] = useState([
    // { label: "Active", count: 0 },
    // { label: "InActive", count: 0 },
  ]);
  const [data, setData] = useState([]);
  const queryClient = useQueryClient();
  const onError = (data) => setAlert(<Error_ data={data} onChange={setAlert} />);
  const onSuccess = (data) => {
    queryClient.invalidateQueries(["billing-list"]);
    setAlert(<Success data={data} onChange={setAlert} />);
  };

  const addPermission = allowAll || (Boolean(permissions["Billing Setup"]) && permissions["Billing Setup"].findIndex(b => b==="new") !== -1);
  const editPermission = allowAll || (Boolean(permissions["Billing Setup"]) && permissions["Billing Setup"].findIndex(b => b==="edit") !== -1);
  const deactivatePermission = allowAll || (Boolean(permissions["Billing Setup"]) && permissions["Billing Setup"].findIndex(b => b==="deactivate") !== -1);

  useQuery({
    queryKey: ["billing-list", { customerCode, active }],
    queryFn: () => getbillinglistbycustomer({ customerCode,active }),
    onSuccess: (data) => setData(data.data.data),
    onError,
  });

  // useQuery({
  //   queryKey: ["billing-status-count", "status", { customerCode }],
  //   queryFn: () => getBillingStatusCount({ customerCode }),
  //   onSuccess: (data) => setTabs(data.data.data),
  //   onError,
  // });

  const delMutation = useMutation(deactiveBilling, { onSuccess, onError });
  const activeMutation = useMutation(activeBilling, { onSuccess, onError });

  const onNew = () => navigate("/billing/add-new-billing");

  const onEdit = (billingNo,billingName) => navigate("/billing/edit-billing", { state: { billingNo,billingName } });

  const onDelete = (billingNo,billingName) => {
    setDialog(
      <MessageDialog
        title={`Deactivate ${billingName}`}
        onClose={() => setDialog(null)}
        onOk={() => {
          delMutation.mutate({ billingNo });
          setDialog(null);
        }}
      />
    );
  };

  const onActive = (billingNo,billingName) => {
    setDialog(
      <MessageDialog
        title={`Activate ${billingNo,billingName}`}
        onClose={() => setDialog(null)}
        onOk={() => {
          activeMutation.mutate({ billingNo });
          setDialog(null);
        }}
      />
    );
  };

  // const generatestorage = useMutation(generatestoragebilling, {
  //   onSuccess: (data) => {
  //     console.log("Add Success:", data);
  //     setAlert(<Success data={data} onChange={setAlert} />);
  //   },
  //   onError: (error) => {
  //     console.error("Add Error:", error);
  //     setAlert(<Error_ data={error} onChange={setAlert} />);
  //   },
  // });

  const columns = [
    { header: "Customer Code", accessorKey: "customerCode" },
    { header: "Billing Name", accessorKey: "billingName" },
    { header: "Created On", accessorKey: "createdOn" },
    // { header: "Short Name", accessorKey: "shortName" },
    // { header: "Phone No", accessorKey: "phoneNo" },
    // { header: "Fax No", accessorKey: "faxNo" },
    // { header: "Email", accessorKey: "email" },
    {
      header: "Action",
      accessorKey: "action",
      enableColumnFilter: false,
      cell: ({ row }) => {
        const { billingNo,billingName } = row.original;
        if (active) {
          return (
            <>
              <EditButton title="edit billing" onClick={() => onEdit(billingNo,billingName)} />
              {/* <DelButton title="deactivate billing" disabled={!deactivatePermission} onClick={() => onDelete(billingNo,billingName)} /> */}
            </>
          );
        } else {
          // return <ActiveButton title="activate billing" disabled={!editPermission} onClick={() => onActive(billingNo,billingName)} />;
        }
      },
    },
  ];
  return (
    <ListLayout>
      {dialog}
      <MDBox my={3}>
        {alert}
        <BasicTabs tabs={tabs} status={status} setStatus={setStatus} />
      </MDBox>
      <TableCard>
        <MDBox display="flex" justifyContent="space-between" alignItems="flex-start" margin="10px">
          <MDButton variant="gradient" color="info" disabled={!addPermission} onClick={onNew}>
            <Icon>add</Icon>&nbsp;Billing
          </MDButton>
          {/* <MDButton variant="gradient" color="info" 
          onClick={() => {
            const req = {
              customerCode: "EHUB-IWEB",
              startDate: "2024-12-01",
              endDate: "2024-12-04",
            }; // Replace with actual data
            generatestorage.mutate(req);
          }}>
            <Icon>add</Icon>&nbsp;Generatebillingforstorage
          </MDButton> */}
        </MDBox>
        <BasicTable columns={columns} data={data} />
      </TableCard>
    </ListLayout>
  );
}

export default BillingList;
